import { useApiMutation, useApiQuery } from "@/hooks/use-api"
import {
	Channel,
	ChannelApiCreate,
	ChannelApiResponse,
	ChannelEmail,
} from "@/models/channel"

export const useChannels = () =>
	useApiQuery<ChannelApiResponse[]>({ url: "/channels" }, { staleTime: 2 * 60 * 1000 })

export const useCreateChannel = () =>
	useApiMutation<Channel, ChannelApiCreate>({
		url: "/channels",
		method: "POST",
	})

export const useDeleteChannel = () =>
	useApiMutation<{}, {}, { id: string }>({
		url: "/channels/{id}",
		method: "DELETE",
	})

export const useUpdateChannelEmail = () =>
	useApiMutation<ChannelEmail, ChannelEmail, { id: string }>({
		url: "/channels/{id}",
		method: "PATCH",
	})
